import React, { useContext, useState, Fragment } from 'react';
import { AlignCenter } from 'react-feather';
import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import CheckContext from '../../_helper/Customizer';
import { useStateContext } from '../../contexts/ContextProvider';

const Leftbar = () => {
    const { toggleSidebar } = useContext(CheckContext);
    const { sidebarOpen, setSidebarOpen, openCloseSidebar } = useStateContext();

    return (
        <Fragment>
            <div className="main-header-left">
                <div className="logo-wrapper">
                    <Link to={`${process.env.PUBLIC_URL}/home`}>
                        <img src={`${require('../../assets/images/logo/logo.png')}`} style={{ width: '30px' }} alt='logo' />
                    </Link>
                </div>
                <div className="toggle-sidebar" onClick={() => openCloseSidebar(sidebarOpen, setSidebarOpen, toggleSidebar)}>
                    <AlignCenter className="status_toggle middle" id="sidebar-toggle" />
                </div>
            </div>
        </Fragment >
    );
};

export default Leftbar;